;(function($, window, document){
    window.LocationMap = Me.view.extend({
        options: {
            map: null
        },

        initialize: function() {
            _.bindAll(this, 'initMap', 'addAddress', 'resizeHandler');
            this.addEvents();

            this.initMap();
            this.addAddress();
        },
        addEvents: function() {
            $(window).on('resize', this.resizeHandler);
        },
        initMap: function(){
            this.options.map = new google.maps.Map(this.$('#map-ctn')[0], {
                zoom: 12,
                center: {lat: 45.5017, lng: -73.5673},
                styles: [
                    {elementType: 'geometry', stylers: [{color: '#d0d9d4'}]},
                    {elementType: 'labels.text.stroke', stylers: [{color: '#d0d9d4'}]},
                    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                    {
                        featureType: 'administrative.locality',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#696969'}]
                    },
                    {
                        featureType: 'administrative.locality',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#d0d9d4'}]
                    },

                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#616463'}]
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#d0d9d4'}]
                    },

                    {
                        featureType: 'poi.park',
                        elementType: 'geometry',
                        stylers: [{color: '#b6c7bd'}]
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#6b9a76'}]
                    },

                    {
                      featureType: 'transit',
                      elementType: 'geometry',
                      stylers: [{color: '#9da39f'}]
                    },
                    {
                      featureType: 'transit.station',
                      elementType: 'labels.text.fill',
                      stylers: [{color: '#696969'}]
                    },
                    {
                      featureType: 'transit.station',
                      elementType: 'labels.text.stroke',
                      stylers: [{color: '#d0d9d4'}]
                    },

                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{color: '#c8d1cc'}]
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry.stroke',
                        stylers: [{color: '#9da39f'}]
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#c8d1cc'}]
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#9da39f'}]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{color: '#c8d1cc'}]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry.stroke',
                        stylers: [{color: '#9da39f'}]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#9da39f'}]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#c8d1cc'}]
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{color: '#b8c7c0'}]
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#9da39f'}]
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#9da39f'}]
                    }
                ]
            });
        },
        addAddress: function(){
            var view = this;
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({'address': this.$('#map-ctn').attr('data-address')}, function(results, status) {
                if (status === 'OK') {
                    view.options.map.setCenter(results[0].geometry.location);
                    var marker = new google.maps.Marker({
                        map: view.options.map,
                        icon: view.$('#map-ctn').attr('data-icon'),
                        position: results[0].geometry.location
                    });

                    view.options.position = results[0].geometry.location;

                    view.options.map.setZoom(16);
                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                }
            })
        },
        resizeHandler: function(){
            if(this.options.position){
                this.options.map.setCenter(this.options.position);
            }
        }
    });
}(jQuery, window, document));
